
const CCNavigationUtils = {
    getTabNavigatorNextState(navigator, action, state, tabName){


    }
};

export  {CCNavigationUtils};


// WEBPACK FOOTER //
// ./src/app/lib/CCNavigationUtils.js